// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AimOutlinedSvg from "@ant-design/icons-svg/es/asn/AimOutlined";
import AntdIcon from '../components/AntdIcon';

var AimOutlined = function AimOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AimOutlinedSvg
  }));
};

AimOutlined.displayName = 'AimOutlined';
export default /*#__PURE__*/React.forwardRef(AimOutlined);